import {Observable} from 'rxjs';
import {get} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {ProfileUserState} from '../entity';
import {SearchApiObservableService} from '../../../../../shared/filter/search-api-observable.service'
import {ProfileUsersFilteringModel} from "../entity/profile-users-filter-model";
import {ProfileRoleFull, ProfileUser, ProfileUsers, UserSecurityActivity} from "../../../../../shared/api/entity/profile.users";

@Injectable()
export class CustomerProfileUsersService {

    constructor(private _http: Http,
                private _searchApiObservableService: SearchApiObservableService) {
    }

    getProfileStatesForRegisteredClients(): Observable<[ProfileUserState]> {
        return this._http.get('/api/backoffice/customers/registered/users/states').map(response => response.json());
    }

    getAllProfileUsers(profileId: number, filterModel: ProfileUsersFilteringModel): Observable<ProfileUsers> {
        return this._searchApiObservableService
            .searchRequestForUrl(`/api/backoffice/customers/${profileId}/users/search`, filterModel);
    }

    getProfileUserDetail(profileId: number, profileUserId: number): Observable<ProfileUser> {
        return this._http.get(`/api/backoffice/customers/${profileId}/users/${profileUserId}/details`).map(response => response.json());
    }

    getProfileUserRoleDetail(profileUserRoleId: number): Observable<ProfileRoleFull> {
        return this._http.get(`/api/backoffice/customers/profile-user-role/details/${profileUserRoleId}`).map(response => response.json());
    }

    getProfileUserRoleAccounts(profileId: number, profileUserRoleId: number): Observable<ProfileRoleFull> {
        return this._http.get(`/api/backoffice/customers/profile/${profileId}/role-accounts/${profileUserRoleId}`).map(response => response.json());
    }

    addAccount(profileUserRoleId: number, accountId: number): Observable<any> {
        return this._http.post('api/backoffice/customers/account/' + profileUserRoleId + '/' + accountId, {})
            .map((request) => {
                const body = request.json();
                return {
                    message: body.message.toString(),
                }
            });
    }

    deleteAccountFromRole(profileUserRoleId: number, accountId: number): Observable<any> {
        return this._http.post('api/backoffice/customers/delete-account-role/' + profileUserRoleId + '/' + accountId, {})
            .map((request) => {
                const body = request.json();
                return {
                    message: body.message.toString(),
                }
            });
    }

    // Moves the user from a role shared with other users to a copy of it of its own (same permissions and accounts)
    giveOwnRole(profileId: number, profileUserId: number): Observable<{ message: string }> {
        return this._http.post(`/api/backoffice/customers/${profileId}/users/${profileUserId}/own-role`, {})
            .map(response => response.json());
    }

    // ADMIN_ROLE: every account of the customer, full permissions and the CO admin section
    makeAdministrator(profileId: number, profileUserId: number): Observable<{ message: string }> {
        return this._http.post(`/api/backoffice/customers/${profileId}/users/${profileUserId}/admin-role`, {})
            .map(response => response.json());
    }

    // The user goes back to a role of their own (USER_<id>)
    removeAdministrator(profileId: number, profileUserId: number): Observable<{ message: string }> {
        return this._http.post(`/api/backoffice/customers/${profileId}/users/${profileUserId}/remove-admin-role`, {})
            .map(response => response.json());
    }

    active2FA(profileUserId: number): Observable<any> {
        return this._http.post('api/backoffice/customers/twoFa/enable/' + profileUserId, {})
            .map(() => ({}));
    }

    disable2FA(profileUserId: number): Observable<any> {
        return this._http.post('api/backoffice/customers/twoFa/disable/' + profileUserId, {})
            .map(() => ({}));
    }

    disableTotp(profileUserId: number): Observable<any> {
        return this._http.post(`api/backoffice/customers/twoFa/totp/disable/${profileUserId}`, {})
            .map(() => ({}));
    }

    get2FAStatus(profileUserId: number): Observable<{userId: number, username: string, emailSmsEnabled: boolean, totpEnabled: boolean}> {
        return this._http.get(`api/backoffice/customers/twoFa/status/${profileUserId}`)
            .map(response => response.json());
    }

    getSecurityActivity(profileId: number, profileUserId: number): Observable<UserSecurityActivity> {
        return this._http.get(`/api/backoffice/customers/${profileId}/users/${profileUserId}/security-activity`)
            .map(response => response.json());
    }

    updateUserPhone(profileId: number, profileUserId: number, phone: string): Observable<any> {
        return this._http.put(`/api/backoffice/customers/${profileId}/users/${profileUserId}/phone`, { phone: phone })
            .map(() => ({}));
    }

    changeProfileUserState(userId: number, state: string): Observable<ProfileUser> {
        return this._http
            .patch(`/api/backoffice/customers/${userId}/update/state`, {state: state})
            .map(response => response.json());
    }

    addUser(email: string, profileId: number): Observable<any> {

        return this._http.patch(`api/backoffice/customers/${profileId}/new-user`, {
            email: email
        })
            .map((request) => {
                const body = request.json();
            });
    }

    // Manual creation of an authorised (secondary) user, collecting the same mandatory data the
    // invitation form would collect. Returns the generated credentials { email, password, userId }.
    createAuthorisedUserManually(profileId: number, request: {
        email: string,
        firstName: string,
        lastName: string,
        middleName?: string,
        dateOfBirth: string,        // yyyy-MM-dd
        phone: string,
        passportId: string,
        nationalityId: number,
        passportIssueDate: string,  // yyyy-MM-dd
        passportExpiryDate: string, // yyyy-MM-dd
        issueCountryId: number,
        issuePlace: string
    }): Observable<{ email: string, password: string, userId: number }> {
        return this._http
            .post(`/api/backoffice/customers/${profileId}/authorised-user`, request)
            .map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/customer-profile-users.service.ts